<template>
  <v-flex xs12 sm10 md8 lg7>
    <v-card class="py-4">
      <v-flex xs12 pb-3 px-4 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 px-4 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-layout row wrap justify-space-between align-center class="px-2">
          <v-flex xs12 sm6 px-3>
            <v-autocomplete
              :items="companies"
              :label="$lang.actions.selectCompany"
              v-model="appResource.companyId"
              item-text="name"
              item-value="id"
              required
              :readonly="isEdit"
              :loading="companyLoading"
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-flex xs12 sm6 px-3>
            <v-text-field
              :label="$lang.labels.name"
              v-model="appResource.name"
              required
              :rules="[v => !!v || `${$lang.errors.missingAppResName}`]"
            />
          </v-flex>
          <v-flex xs12 sm6 px-3>
            <v-autocomplete
              :items="appResourceTypes"
              :label="$lang.actions.selectAppResType"
              v-model="appResource.type"
              :readonly="isEdit"
              required
              :rules="[() => appResource.type.length > 0 || `${$lang.errorsAppResType}`]"
            />
          </v-flex>
          <v-flex xs12 sm6 px-3>
            <v-autocomplete
              :items="subscriptionModels"
              :label="$lang.actions.selectAppResSubModel"
              v-model="appResource.subscriptionModel"
              required
              :rules="[() => appResource.subscriptionModel.length > 0 || `${$lang.errors.missingAppResSubModel}`]"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-between class="px-2">
            <v-text-field
              v-if="isEdit && createdOn"
              :label="$lang.labels.created"
              v-model="createdOn"
              readonly
              class="min-w max-w mx-3"
            />
            <v-text-field
              v-if="isEdit && modifiedOn"
              :label="$lang.labels.modified"
              v-model="modifiedOn"
              readonly
              class="min-w max-w mx-3"
            />
          </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="mt-2 px-4">
          <v-btn 
            flat class="ml-0" 
            @click="$router.push({ name: 'appResources' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <v-btn
            class="primary mx-0" 
            :disabled="!valid" 
            @click="submit">
            {{ isEdit ? $lang.actions.update : $lang.actions.create}}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    data: () => ({
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      companies: [],
      appResource: {
        companyId: null,
        name: null,
        type: null,
        subscriptionModel: null,
      },
      createdOn: null,
      modifiedOn: null,
      appResourceTypes: [],
      subscriptionModels: [],
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    methods: {
      formatDate(date) {
         return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      init() {
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('system/appresource/fetchtypes')
            .then((res) => {
              resolve()
              if (res.body.status === 'Success') {
                this.appResourceTypes = res.body.appResourceTypes;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('system/appresource/fetchsubscriptionmodels')
            .then((res) => {
              resolve()
              if (res.body.status === 'Success') {
                this.subscriptionModels = res.body.subscriptionModels;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      submit() {
        let url = this.isEdit ? `appresource/update/${this.$route.params.id}` : 'appresource/create';
        this.$http.post(url, this.appResource)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = this.isEdit ? 'App Resource updated successfuly' : 'App Resource created successfuly';
              setTimeout(() => {
                if (this.isEdit) {
                  this.success = '';
                } else {
                  this.$router.push({ name: 'appResources' });
                }
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.init()
        .then(() => {
          if (this.$route.params.id) {
            this.isEdit = true;
            this.$http.get(`appresource/${this.$route.params.id}`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  this.appResource = res.body.appResource;
                  this.createdOn = this.formatDate(this.appResource.createdOn);
                  if (this.appResource.modifiedOn) {
                    this.modifiedOn = this.formatDate(this.appResource.modifiedOn);
                  }
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
            }
        })
    },
  };
</script>



// WEBPACK FOOTER //
// AppResourceDetails.vue?f497a3ee